import React, { ComponentProps, FC, ReactNode, useRef } from 'react';
import { FieldValueType } from 'api/tasks';
import {
  ActionPanel,
  usePopoverActionRef,
} from 'components/molecules/action-panel';
import { DateFieldEditorPopover } from 'components/organisms/field-editors/date/date-field-editor-popover';
import { DateField } from 'components/organisms/tasks/fields';
import { TaskField } from 'stores/fields';
import { queueMacrotask } from 'utils/macrotask';
import { DatePopoverAction } from './components';

export type OnChange = (field: TaskField, to: FieldValueType) => void;

const { PopoverAction } = ActionPanel;

interface Props {
  date: DateField;
  title: ReactNode;
  allowed: ComponentProps<typeof PopoverAction>['allowed'];
  onChange: OnChange;
  innerRef?: ReturnType<typeof usePopoverActionRef>;
}

export const SetDate: FC<Props> = ({
  date,
  title,
  allowed,
  onChange,
  innerRef,
}) => {
  const ref = useRef<DateFieldEditorPopover>(null);

  return (
    <DatePopoverAction
      ref={innerRef}
      title={title}
      allowed={allowed}
      onShow={() => queueMacrotask(() => ref.current?.focus())}
    >
      <DateFieldEditorPopover
        ref={ref}
        field={date}
        title={title}
        onChange={(latest: string | null) =>
          onChange(date as TaskField, latest)
        }
      />
    </DatePopoverAction>
  );
};
